.results {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem;

  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

@media (width < 500px) {
  .results {
    padding: 1rem;
    gap: 1rem;
  }
}

.results header {
  display: flex;
  flex-direction: column;
  justify-content: center;

  font-weight: bold;
  font-size: 2rem;
}

@media (width < 500px) {
  .results header {
    font-size: 1.35rem;
  }
}

.score-container {
  font-size: 1.25rem;
}

@media (width < 500px) {
  .score-container {
    font-size: 1rem;
  }
}

.score-card thead {
  font-weight: bold;
}

.score-card td,
th {
  padding: 0.75rem;
  border: 2px dotted lightslategray;
}

.buttons-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

@media (width < 500px) {
  .buttons-container {
    gap: 0.5rem;
  }
}

.buttons-container button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;

  border: 0;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: black;
  color: white;

  cursor: pointer;
}

.buttons-container img {
  width: 30px;
}

@media (width < 500px) {
  .buttons-container img {
    width: 25px;
  }
}
